import React from 'react'
import HomeContact from '../components/homepage/HomeContact'

function Contact() {
  return (
    <>
      <section className='contact'>
        <h1>Contact Us</h1>
        <p>Get in touch with our team.</p>
      </section>
      <HomeContact/>
    </>
  )
}

export default Contact